import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";

import * as R from "ramda";

import { trackMaterialClick } from "~/libs/matomo";

import CircularProgress from "@mui/material/CircularProgress";
import Divider from "@mui/material/Divider";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";

import { getAttachments, getDocumentUrl, getAttachmentUrl } from "~/libs/upload";

import MaterialRenderer from "~/components/MaterialRenderer";
import AttachmentsTable from "../../AttachmentsTable";

import DialogHeader from "./DialogHeader";
import DialogFooter from "./DialogFooter";

// If renderType is provided and not empty, then use it...else use the given materialType
const determineMaterialType = material =>
  R.ifElse(R.compose(R.isEmpty, R.propOr("", "renderType")), R.prop("materialType"), R.prop("renderType"))(material);

class ShowMaterialModal extends Component {
  state = {
    attachments: {},
    loading: true
  };

  componentDidMount() {
    const { material, page } = this.props;
    const { _id: id, title } = material;

    trackMaterialClick({ page, title });

    getAttachments(id).then(attachments => this.setState({ attachments, loading: false }));
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.attachments.length !== this.state.attachments.length && this.state.attachments.length === 1) {
      if (determineMaterialType(this.props.material) === "audio") {
        // this.audioRef.current.pause();
        // this.audioRef.current.load();
      }

      if (determineMaterialType(this.props.material) === "video") {
        // this.videoRef.current.pause();
        // this.videoRef.current.load();
      }
    }
  }

  handleOnEditClick = () => this.props.switchModal("EDIT_MATERIAL");

  handleOnCloseClick = () => this.props.hideModal();

  render() {
    const { material, kind } = this.props;
    const { attachments, loading } = this.state;
    const materialType = determineMaterialType(material);

    const numberOfAttachments = R.length(attachments);
    const linktext = R.defaultTo("", material.linktext);

    let sourcePath;
    let mimeType;
    let content;

    if (numberOfAttachments === 1) {
      const { name, payload } = R.head(attachments);
      sourcePath = getAttachmentUrl(getDocumentUrl(material._id), name);
      mimeType = payload.content_type;
    } else {
      sourcePath = material.src;
    }

    content = (
      <MaterialRenderer renderType={materialType} sourcePath={sourcePath} mimeType={mimeType} linkText={linktext} />
    );

    return (
      <>
        <DialogHeader title={`Details: ${material.title}`} isCloseableOnly={false} id={`${kind}-modal-title`} />

        <DialogContent>
          <DialogContentText>{material.description}</DialogContentText>

          <br />

          {loading ? (
            <div style={{ textAlign: "center" }}>
              <CircularProgress />
            </div>
          ) : (
            content
          )}

          {!numberOfAttachments > 1 && !loading && (
            <div>
              <AttachmentsTable material={this.props.material} attachments={this.state.attachments} editable={false} />
            </div>
          )}
        </DialogContent>
        <DialogFooter isEditMode={this.props.isEditMode} />
      </>
    );
  }
}

ShowMaterialModal.propTypes = {
  hideModal: PropTypes.func.isRequired,
  material: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  page: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isEditMode: PropTypes.bool.isRequired,
  kind: PropTypes.string.isRequired
};

export default ShowMaterialModal;
